import React, { useRef } from "react"
import {
  FormControl, FormLabel, Input, LayoutProps, ThemingProps,
} from "@chakra-ui/react"
import { useController, Control } from "react-hook-form"

type Props = {
  control: Control<any>
  name: string
  label?: string
  required?: boolean
  variant?: ThemingProps["variant"]
  w?: LayoutProps["w"]
}

const BirthdatePicker = ({
  control,
  name,
  label,
  required = false,
  variant,
  w = 48,
}: Props) => {
  const {
    field: { value, onChange },
  } = useController({ name, control })
  const inputRef = useRef<HTMLInputElement>(null)

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.focus()

      // Chrome 99+ supports showPicker
      if (typeof inputRef.current.showPicker === "function") {
        inputRef.current.showPicker()
      }
    }
  }

  return (
    <FormControl isRequired={required}>
      {label && (
        <FormLabel
          color="gray.700"
          fontSize="sm"
          fontWeight="semibold"
          htmlFor={name}
        >
          {label}
        </FormLabel>
      )}
      <Input
        id={name}
        ref={inputRef}
        w={w}
        type="date"
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        max={new Date().toISOString().split("T")[0]}
        onClick={handleClick}
        variant={variant}
        sx={{
          cursor: "pointer",
        }}
      />
    </FormControl>
  )
}

export default BirthdatePicker
